/**
 * Mirrors `com.jmotto.multi.quote.QuoteSourceEnum` on the backend.
 *
 * Stored in `str_quote.source` (column added 2026-05-07) so the Quote
 * Analytics dashboard can break down volume / conversion / revenue by entry
 * point and show the team which creation tool is most effective.
 *
 * @since 2.6 (quote analytics feature)
 */
export enum QuoteSource {
  /** Created in response to an inbound email (sourceMsgId set) — built
   *  directly from the inbox without going through best-fit. */
  INBOX_REPLY    = 1,

  /** Best-fit finder opened as a standalone page. */
  BEST_FIT       = 2,

  /** Best-fit finder opened from the inbox flow. The most common comm-tool
   *  path: agent reads an inbox message and clicks Best Fit Finder. */
  INBOX_BEST_FIT = 3,

  /** Manual create from the Quote List page. */
  QUOTE_LIST     = 4,

  /** Tape-chart-wiki — agent picked a date range and built a quote
   *  directly from the calendar. */
  TAPE_CHART     = 5,

  /** Fallback / legacy. */
  OTHER          = 6,
}
